import React from 'react';
import { clsx } from 'clsx';

export type InputSize = 'sm' | 'md';

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  error?: boolean;
  leftIcon?: React.ReactNode;
  inputSize?: InputSize;
}

const SIZE_CLASSES: Record<InputSize, string> = {
  sm: 'h-8 px-2 text-xs',
  md: 'h-10 px-3 text-sm',
};

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ error, leftIcon, inputSize = 'md', className, ...rest }, ref) => {
    const input = (
      <input
        ref={ref}
        className={clsx(
          'w-full bg-surface text-text placeholder:text-text-mute rounded',
          'border border-border-strong',
          'focus:outline-none focus:border-accent focus:ring-2 focus:ring-accent/20',
          'disabled:opacity-50 disabled:cursor-not-allowed',
          error && 'border-err focus:border-err focus:ring-err/20',
          SIZE_CLASSES[inputSize],
          leftIcon && 'pl-9',
          className,
        )}
        {...rest}
      />
    );
    if (!leftIcon) return input;
    return (
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-text-mute pointer-events-none">{leftIcon}</span>
        {input}
      </div>
    );
  },
);
Input.displayName = 'Input';
